import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import { signUpload } from "@culturehq/client";
import sanitizeJSONString from "app/utils/sanitizeJSONString";

const appendInlineLinks = raw => {
  const entityMap = { ...raw.entityMap };
  const lastKey = Object.keys(raw.entityMap).slice(-1).pop() || -1;
  let lastElement = parseInt(lastKey, 10);
  const blocks = [];
  raw.blocks.forEach(section => {
    const matches = section.text.match(/\bhttps?:\/\/\S+/gi);
    if (!matches) {
      blocks.push(section);
      return;
    }

    const entityRanges = [];
    matches.forEach(url => {
      let found = false;
      Object.keys(entityMap).forEach(key => {
        if (entityMap[key].data.url === url) {
          found = true;
        }
      });

      if (found) {
        blocks.push(section);
      } else {
        lastElement += 1;
        entityRanges.push({
          offset: section.text.indexOf(url),
          length: url.length,
          key: lastElement
        });

        entityMap[lastElement] = {
          data: { url },
          mutability: "MUTABLE",
          type: "LINK"
        };
        blocks.push({ ...section, entityRanges });
      }
    });
  });
  return { blocks, entityMap };
};

export const serializeEditor = async (editorState, onProgress) => {
  const raw = convertToRaw(editorState.getCurrentContent());
  const promises = [];

  const { blocks, entityMap } = appendInlineLinks(raw);
  raw.blocks = blocks;
  raw.entityMap = entityMap;

  Object.keys(raw.entityMap).forEach(entityKey => {
    const entity = raw.entityMap[entityKey];

    if (entity.type === "IMAGE" && entity.data.file) {
      const promise = signUpload(entity.data.file, progress => {
        onProgress(entityKey, progress);
      }).then(imageUrl => {
        entity.data.src = imageUrl;
        delete entity.data.file;
      });

      promises.push(promise);
    }
  });

  await Promise.all(promises);
  return JSON.stringify(raw);
};

export const deserializeEditor = initialValue => {
  if (initialValue) {
    let contentState;
    if (!initialValue.startsWith("{\"blocks\"")) {
      contentState = convertFromRaw(JSON.parse(`{"blocks":[{"key":"67gb3","text":"${sanitizeJSONString(initialValue)}","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`));
    } else {
      contentState = convertFromRaw(JSON.parse(initialValue));
    }
    return EditorState.createWithContent(contentState);
  }

  return EditorState.createEmpty();
};
